import { PageRef } from 'providers/page-ref';

export type CoachSettingsPageParams = {};

export const ICoachSettingsPage: PageRef<CoachSettingsPageParams, void> = {
  pageName: 'CoachSettingsPage',
} as PageRef<CoachSettingsPageParams, void>;
